// extracted by mini-css-extract-plugin
module.exports = {"MyAccountPage":"MyAccountPage_MyAccountPage__8qZX_","Visited":"MyAccountPage_Visited__56GNF"};